export const register = {
    header: 'Register',
    messages: {
        registerSuccess: 'Your account has been created and being reviewed',
    },
    registerForm: {
        register: 'Register',
        signIn: 'Sign in',
        or: 'or',
        firstName: {
            label: 'First name',
            placeholder: 'First name',
        },
        lastName: {
            label: 'Last name',
            placeholder: 'Last name',
        },
        email: {
            label: 'Email',
            placeholder: 'Email',
        },
        countryId: {
            label: 'Country',
            placeholder: 'Country',
        },
        language: {
            label: 'Language',
            placeholder: 'Language',
        },
        projectName: {
            label: 'Project name',
            placeholder: 'Project name',
        },
        projectAdminEmail: {
            label: 'Project admin email',
            placeholder: 'Project admin email',
        },
        module: {
            label: 'Module',
            constellation: 'Register module Spacialytic Constellation',
            '3dViewer': 'Register module Spacialytic 3D Viewer',
        },
    },
};
